export const actionTypes = {
  // authentication
  FETCH_USER: 'FETCH_USER',
  FETCHED_USER: 'FETCHED_USER',
  UPDATE_USER: 'UPDATE_USER',
  UPDATED_USER: 'UPDATED_USER',
  UPDATE_USER_ERROR: 'UPDATE_USER_ERROR',
  SIGN_OFF: 'SIGN_OFF',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  CREATE_USER: 'CREATE_USER',
  CREATED_USER: 'CREATED_USER',
  USER_NOT_CREATED: 'USER_NOT_CREATED',
  UNSUBSCRIBE_USER: 'UNSUBSCRIBE_USER',
  UNSUBSCRIBED_USER: 'UNSUBSCRIBED_USER',
  SET_AUTH_LOADING: 'SET_AUTH_LOADING',

  // email
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  CONFIRMED_EMAIL: 'CONFIRMED_EMAIL',
  SUBSCRIBE_DAILY_EMAIL: 'SUBSCRIBE_DAILY_EMAIL',
  SUBSCRIBED_DAILY_EMAIL: 'SUBSCRIBED_DAILY_EMAIL',
  SUBSCRIBE_YOUR_WEEKLY_EMAIL: 'SUBSCRIBE_WEEKLY_EMAIL',
  SUBSCRIBED_YOUR_WEEKLY_EMAIL: 'SUBSCRIBED_WEEKLY_EMAIL',
  SUBSCRIBE_WEEKLY_EMAIL: 'SUBSCRIBE_WEEKLY_EMAIL',
  SUBSCRIBED_WEEKLY_EMAIL: 'SUBSCRIBED_WEEKLY_EMAIL',
  SWITCH_TO_DAILY_EMAIL: 'SWITCH_TO_DAILY_EMAIL',
  SWITCHED_TO_DAILY_EMAIL: 'SWITCHED_TO_DAILY_EMAIL',
  SWITCH_TO_WEEKLY_EMAIL: 'SWITCH_TO_WEEKLY_EMAIL',
  SWITCHED_TO_WEEKLY_EMAIL: 'SWITCHED_TO_WEEKLY_EMAIL',
  UNSUBSCRIBE_EMAIL: 'UNSUBSCRIBE_EMAIL',
  UNSUBSCRIBED_EMAIL: 'UNSUBSCRIBED_EMAIL',
  UNSUBSCRIBE_DAILY_EMAIL: 'UNSUBSCRIBE_DAILY_EMAIL',
  UNSUBSCRIBED_DAILY_EMAIL: 'UNSUBSCRIBED_DAILY_EMAIL',
  UNSUBSCRIBE_YOUR_WEEKLY_EMAIL: 'UNSUBSCRIBE_WEEKLY_EMAIL',
  UNSUBSCRIBED_YOUR_WEEKLY_EMAIL: 'UNSUBSCRIBED_WEEKLY_EMAIL',
  UNSUBSCRIBE_WEEKLY_EMAIL: 'UNSUBSCRIBE_WEEKLY_EMAIL',
  UNSUBSCRIBED_WEEKLY_EMAIL: 'UNSUBSCRIBED_WEEKLY_EMAIL',
  UNSUBSCRIBE_CHAT_EMAIL: 'UNSUBSCRIBE_CHAT_EMAIL',
  UNSUBSCRIBED_CHAT_EMAIL: 'UNSUBSCRIBED_CHAT_EMAIL',
  UNSUBSCRIBE_NEW_EMAIL: 'UNSUBSCRIBE_NEW_EMAIL',
  UNSUBSCRIBED_NEW_EMAIL: 'UNSUBSCRIBED_NEW_EMAIL',
  UNSUBSCRIBE_SURVEY_EMAIL: 'UNSUBSCRIBE_SURVEY_EMAIL',
  UNSUBSCRIBED_SURVEY_EMAIL: 'UNSUBSCRIBED_SURVEY_EMAIL',
  UNSUBSCRIBE_OFFER_EMAIL: 'UNSUBSCRIBE_OFFER_EMAIL',
  UNSUBSCRIBED_OFFER_EMAIL: 'UNSUBSCRIBED_OFFER_EMAIL',
  UNSUBSCRIBE_EMAIL_PERMISSION: 'UNSUBSCRIBE_EMAIL_PERMISSION',
  UNSUBSCRIBED_EMAIL_PERMISSION: 'UNSUBSCRIBED_EMAIL_PERMISSION',

  // experiments
  FETCH_EXPERIMENTS: 'FETCH_EXPERIMENTS',
  FETCHED_EXPERIMENTS: 'FETCHED_EXPERIMENTS',
  SAVE_USER_EXPERIMENTS: 'SAVE_USER_EXPERIMENTS',
  CHOOSE_EXPERIMENTS: 'CHOOSE_EXPERIMENTS',
  CHOSEN_EXPERIMENTS: 'CHOSEN_EXPERIMENTS',

  // background image
  FETCH_BACKGROUND_IMAGE: 'FETCH_BACKGROUND_IMAGE',
  FETCHED_BACKGROUND_IMAGE: 'FETCHED_BACKGROUND_IMAGE',

  // payment
  FETCH_SUBSCRIPTION: 'FETCH_SUBSCRIPTION',
  FETCHED_SUBSCRIPTION: 'FETCHED_SUBSCRIPTION',
  FETCH_PRICING: 'FETCH_PRICING',
  FETCHED_PRICING: 'FETCHED_PRICING',
  PROCESS_PAYMENT: 'PROCESS_PAYMENT',
  PROCESSED_PAYMENT: 'PROCESSED_PAYMENT',
  SET_UTM: 'SET_UTM',
  SET_PRICING_CAMPAIGN: 'SET_PRICING_CAMPAIGN',

  // campaigns
  FETCH_PRICING_CAMPAIGN: 'FETCH_PRICING_CAMPAIGN',
  FETCHED_PRICING_CAMPAIGN: 'FETCHED_PRICING_CAMPAIGN',
  FETCH_GIFT_CAMPAIGN: 'FETCH_GIFT_CAMPAIGN',
  FETCHED_GIFT_CAMPAIGN: 'FETCHED_GIFT_CAMPAIGN',
  REDEEM_GIFT: 'REDEEM_GIFT',
  REDEEM_GIFT_SUCCESS: 'REDEEM_GIFT_SUCCESS',
  REDEEM_GIFT_ERROR: 'REDEEM_GIFT_ERROR',

  // referral
  FETCH_REFERRER: 'FETCH_REFERRER',
  FETCHED_REFERRER: 'FETCHED_REFERRER',
  REFERRER_NOT_FOUND: 'REFERRER_NOT_FOUND',

  // user
  LISTEN_LATER: 'LISTEN_LATER',
  LISTENED_LATER: 'LISTEN_LATER',

  FETCH_INDICES: 'FETCH_INDICES',
  RECEIVE_INDICES: 'RECEIVE_INDICES',
};
